import { AppMenuSavedDashboardInterface } from 'src/types/AppMenuInterface'
import { isTrueOrUndefinedFn } from './booleanUtils'
import { FROM_CROSS_LAUNCHING_KEY } from './constants/CrossLaunching'

/**
 * Get default dashboard
 * Get dashboard from param or favorite dashboard or default dashboard or first dashboard
 * Return null if no dashboard found
 */
export const getDefaultDashboardFn = ({
  dashboards,
  dashboardParamId,
  from,
}: {
  dashboards: AppMenuSavedDashboardInterface[]
  dashboardParamId?: string
  from?: string
}): AppMenuSavedDashboardInterface | null => {
  if (!dashboardParamId) {
    if (from === 'launch_in' || from === FROM_CROSS_LAUNCHING_KEY) {
      return null
    }
  }
  const dashboardsWithAccess = dashboards.filter(d => isTrueOrUndefinedFn(d.has_access))
  if (!dashboardsWithAccess?.length) {
    return null
  }
  // Dashboard from param
  if (dashboardParamId) {
    const dashboard = dashboardsWithAccess.find(d => d.id === dashboardParamId)
    if (dashboard) {
      return dashboard
    }
  }

  return dashboardsWithAccess.find(d => d.favorite) || null
}
